import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import android from "../../images/android.png";
import ios from "../../images/ios.png";
import { androidUrl, footerData, iosUrl } from '../../config';
import '../footer/footer.css'
import { Link } from 'react-router-dom';
import mobile from '../../images/mobile.png'
import logo from '../../images/logo.png'
export default function Footer() {
  const clientData = useSelector((state) => state.clientDetails)[0];

  return (
    <>
      <footer>
        <div className="footer-cover">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-12 align-self-center">
                <div className="cnt-cover app-iconlogo">
                  <h2>AVAILABLE ON</h2>
                  <div className="app-icon">
                    <Link to={androidUrl} target='_blank'>
                      <img src={android} />
                    </Link>
                    {/* <Link to={iosUrl} target='_blank'>
                <img src={ios} />
              </Link> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6 align-self-center">
                <div className="cnt-cover">
                  <h2>
                    <i className="fa fa-phone" />
                    BOOKING NUMBER
                  </h2>
                  <p>
                    {" "}
                    <span className="bookingno3">{clientData?.number1}</span> |{" "}
                    <span className="bookingno2">{clientData?.number2}</span>{" "}
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6 align-self-center">
                <div className="cnt-cover">
                  <h2>
                    <i className="fa fa-envelope" />
                    E-MAIL ADDRESS
                  </h2>
                  <p>
                    <span className="email1">{clientData?.email1}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="cover-copyright">
          <div className="container">
            <div className="row">
              <div className="col-md-12 ">
                <div className="cover-copyright-tittle">
                  <h6>{footerData.copyright}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!!clientData?.marqueeBottom && <div className="header-top-marquee">
          <div className="container-fluid">
            <marquee className="marquee2">{clientData?.marqueeBottom}</marquee>
          </div>
        </div>}

      </footer>

    </>


  )
}
